import { DEFAULT_LOCALE, LOCALES } from '../locale/constants';
import { detectLocale } from '../locale/detectLocale';

let activeLocale = detectLocale();

export function getActiveLocale() {
  return LOCALES.includes(activeLocale) ? activeLocale : DEFAULT_LOCALE;
}

export function setActiveLocale(locale) {
  if (LOCALES.includes(locale)) {
    activeLocale = locale;
  }
}
